module.exports = __webpack_public_path__ + "img/lg_ring_y_i_1_0@3x.25e96b95.png";